import service from '@/api/service/service';
import qs from "qs";

// 信息回显
export function info_view(params = {}) {
  return service({
    url: "/api/main/stu_singn_info_view.json",
    method: 'get',
    params: params,
  });
}

// 保存学员信息
export function saveInfo(data = {}) {
  return service({
    url: "/api/main/student_singn_info.json",
    method: 'post',
    data: qs.stringify(data),
  });
}

// 上传意见反馈文件
export function feedback_save(data = {}) {
  return service({
    url: "/api/organization/feedback_save.json",
    method: 'post',
    data: qs.stringify(data),
  });
}

// 保存学员基本信息
export function student_sign_info_one(data = {}) {
  return service({
    url: "/api/main/student_sign_info_one.json",
    method: 'post',
    data: qs.stringify(data),
  });
}

// 保存学员资质信息
export function student_sign_info_two(data = {}) {
  return service({
    url: "/api/main/student_sign_info_two.json",
    method: 'post',
    data: qs.stringify(data),
  });
}
// 学员撤销信息提交
export function info_revocation(data = {}) {
  return service({
    url: "/api/main/info_revocation.json",
    method: 'post',
    data: qs.stringify(data),
  });
}

